// src/hooks/useTodayClosedTaskCount.ts
/**
 * 今日 closed task 數量（Evening 摘要用）
 *
 * 直接從 IndexedDB 讀取，不訂閱 Firestore。
 * 只在 evening phase 時才有意義，呼叫方自行決定是否 mount。
 *
 * 更新時機：
 * - mount 時讀一次
 * - 監聽 TASK_STATUS_CHANGED 事件，有任務被 close/reopen 時重新計算
 */

import { useState, useEffect, useCallback } from 'react';
import { taskRepository } from '../services/indexedDB/repositories/taskRepository';
import { formatDateToString } from '../utils/dateUtils';
import { eventBus, EVENTS } from '../utils/eventBus';
import { logError } from '../utils/logger';

export function useTodayClosedTaskCount(userId: string): number {
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!userId) return;
    try {
      const todayStr = formatDateToString(new Date());
      const result = await taskRepository.countClosedToday(userId, todayStr);
      setCount(result);
    } catch (err) {
      logError('useTodayClosedTaskCount: 讀取失敗', err);
    }
  }, [userId]);

  useEffect(() => {
    refresh();

    // 任務狀態異動時重新計算（task 被 complete 或 reopen）
    const unsub = eventBus.subscribe(EVENTS.TASK.STATUS_CHANGED, refresh);
    return () => unsub();
  }, [refresh]);

  return count;
}
